import { Body } from '@shipt/design-system-typography'
import { IconButton } from '@shipt/design-system-buttons'
import { Stack } from '@shipt/design-system-layouts'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { type PlaceholderData } from '@/features/cms/components/CMS/types'
import { DynamicStoreInfoDrawer } from '@/features/shop/components/Drawer/StoreInfoDrawer/DynamicStoreInfoDrawer'
import { InfoCircleIcon } from '@shipt/design-system-icons'
import { useQueryRetailerFees } from '@/features/shop/services/Fees/queries'
import { useStoreId, useIsUserC360 } from '@/features/account/services/User/hooks'
import { useEffect } from 'react'
import { trackElementViewed } from '@/features/shared/analytics/element'
export const ServiceFeeDisclaimer = ({
  content_type_id,
  id,
}: Pick<PlaceholderData, 'content_type_id' | 'id'>) => {
  const { openDialog } = useHandleDialog()
  const selectedStoreId = useStoreId()
  const { data: retailerFees } = useQueryRetailerFees()
  const isC360User = useIsUserC360()
  const handleInfoIconClick = () => {
    openDialog(DynamicStoreInfoDrawer, {
      defaultTab: 'storeInfo',
    })
  }

  const selectedStoreServiceFee =
    !isC360User && retailerFees?.find((fee) => fee.store_id === selectedStoreId)

  useEffect(() => {
    if (selectedStoreServiceFee) {
      trackElementViewed({
        content: 'service_fee_disclaimer',
        type: 'banner',
      })
    }
  }, [selectedStoreServiceFee])

  if (!selectedStoreServiceFee) return null

  return (
    <GridLayoutContainer {...getCMSWrapperProps({ content_type_id, id })}>
      <Stack align="center" justify="center" spacing="xxs" margin={['xs', 0]}>
        <Body size="sm" lineHeight="compact" variant="secondary">
          {selectedStoreServiceFee.display_value} service fee applies
        </Body>
        <IconButton
          icon={InfoCircleIcon}
          size="sm"
          variant="ghost"
          onClick={handleInfoIconClick}
          aria-label="store pricing policy information"
        />
      </Stack>
    </GridLayoutContainer>
  )
}
